module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": "45px"
    }
  }, [_c('router-view'), _vm._v(" "), _c('tabbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabbarshow),
      expression: "tabbarshow"
    }],
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('tabbar-item', {
    attrs: {
      "link": {
        path: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "icontab",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "icontab icon-browse",
    attrs: {
      "slot": "icon-active"
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Home")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": {
        path: 'menu'
      }
    }
  }, [_c('span', {
    staticClass: "icontab icon-all",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "icontab icon-browse",
    attrs: {
      "slot": "icon-active"
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("All")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": {
        path: 'login'
      },
      "badge": _vm.bus.logined ? '在线' : '匿名'
    }
  }, [_c('span', {
    staticClass: "icontab",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "icontab icon-browse",
    attrs: {
      "slot": "icon-active"
    },
    slot: "icon-active"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("My")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfa308e4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 154
// module chunks = 15